import { memo } from 'react';
import type {
  ReactElement,
} from 'react';

import { useTheme } from 'styled-components';

import { defaultRenderDescription } from './defaultRenderDescription';
import { defaultReload } from './defaultReload';
import type {
  ListPlaceholderProps,
} from './types';

import {
  ListPlaceholderBase,
} from './ListPlaceholderBase';

function ListPlaceholderInner({
  children = 'Не найдено ни одной записи',
  renderDescription = defaultRenderDescription,
  reload = defaultReload,
}: ListPlaceholderProps): ReactElement {
  const {
    colors,
  } = useTheme();

  return (
    <ListPlaceholderBase
      icon={(
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          xmlns="http://www.w3.org/2000/svg"
          fill={colors.NEUTRAL_DEFAULT}
        >
          <path d="M0 23.9998C0 37.2334 10.7663 47.9997 24 47.9997C26.9926 47.9997 29.9121 47.4556 32.6777 46.3824C32.9865 46.2626 33.1397 45.9151 33.0199 45.606C32.9001 45.2966 32.5517 45.1427 32.2435 45.2638C29.6171 46.2828 26.8435 46.7996 24 46.7996C11.4281 46.7996 1.2 36.5715 1.2 23.9998C1.2 17.0293 4.41595 10.4361 9.8537 6.12401V10.1312C9.8537 10.4626 10.1223 10.7313 10.4537 10.7313C10.785 10.7313 11.0537 10.4626 11.0537 10.1312V4.90303C11.0537 4.89428 11.0491 4.88702 11.0487 4.87838C11.0456 4.82161 11.0349 4.76759 11.0153 4.7128C11.0045 4.68101 10.9911 4.65245 10.9754 4.62333C10.9648 4.60436 10.9623 4.58304 10.9494 4.56491C10.9393 4.55074 10.924 4.54371 10.913 4.53067C10.8816 4.49196 10.8462 4.46024 10.8062 4.43039C10.7871 4.4167 10.7693 4.403 10.7489 4.39176C10.6973 4.36172 10.6422 4.3425 10.5822 4.32895C10.5694 4.32627 10.5573 4.32312 10.5443 4.32129C10.5135 4.31642 10.4859 4.30298 10.4537 4.30298H5.22538C4.89404 4.30298 4.62538 4.57165 4.62538 4.90303C4.62538 5.2344 4.89404 5.50308 5.22538 5.50308H8.71837C3.23261 10.0443 0 16.8316 0 23.9998Z" fillOpacity="0.25" />
          <path d="M23.9999 0.000244141C21.203 0.000244141 18.4625 0.477237 15.8551 1.41804C15.5434 1.53026 15.382 1.87423 15.4945 2.18598C15.607 2.49743 15.9503 2.65975 16.2624 2.54665C18.7388 1.65331 21.3421 1.20035 23.9999 1.20035C36.5718 1.20035 46.7999 11.4285 46.7999 24.0002C46.7999 30.7809 43.7267 37.2583 38.5256 41.57V37.5998C38.5256 37.2684 38.257 36.9997 37.9256 36.9997C37.5943 36.9997 37.3256 37.2684 37.3256 37.5998V42.7164C37.3208 42.7454 37.3262 42.7744 37.3256 42.8038V42.8283C37.3256 42.8307 37.327 42.8327 37.327 42.8351C37.3292 42.9011 37.3415 42.9642 37.3658 43.0274C37.3759 43.0556 37.389 43.0804 37.4029 43.1065C37.4149 43.1277 37.4186 43.1515 37.4334 43.1716C37.4418 43.1829 37.4551 43.1868 37.4641 43.1973C37.574 43.3347 37.7359 43.4283 37.9256 43.4283H43.1539C43.4853 43.4283 43.7539 43.1596 43.7539 42.8283C43.7539 42.4969 43.4853 42.2282 43.1539 42.2282H39.6009C44.8855 37.6915 47.9999 31.0008 47.9999 24.0002C47.9999 10.7666 37.2336 0.000244141 23.9999 0.000244141Z" fillOpacity="0.25" />
          <path d="M21.1699 31.1514C23.7054 31.1514 26.0158 30.1929 27.778 28.6292L33.9553 34.8074C34.0725 34.9246 34.226 34.9832 34.3796 34.9832C34.5331 34.9832 34.6866 34.9246 34.8038 34.8074C35.0382 34.573 35.0382 34.1932 34.8038 33.9588L28.6264 27.7807C30.19 26.0183 31.1484 23.7076 31.1484 21.1717C31.1484 15.669 26.6721 11.1924 21.1699 11.1924C15.6677 11.1924 11.1914 15.669 11.1914 21.1717C11.1914 26.6744 15.6677 31.1514 21.1699 31.1514ZM21.1699 12.3925C26.0103 12.3925 29.9484 16.3309 29.9484 21.1717C29.9484 26.0129 26.0103 29.9513 21.1699 29.9513C16.3295 29.9513 12.3914 26.0129 12.3914 21.1717C12.3914 16.3309 16.3295 12.3925 21.1699 12.3925Z" fillOpacity="0.25" />
          <path d="M16.4082 22.3263C16.7395 22.3263 17.0082 22.0577 17.0082 21.7263C17.0082 19.1959 19.0669 17.1373 21.5972 17.1373C21.9286 17.1373 22.1972 16.8686 22.1972 16.5373C22.1972 16.2059 21.9286 15.9373 21.5972 15.9373C18.405 15.9373 15.8082 18.5341 15.8082 21.7263C15.8082 22.0577 16.0768 22.3263 16.4082 22.3263Z" fillOpacity="0.25" />
        </svg>
      )}
      renderDescription={renderDescription}
      reload={reload}
    >
      {children}
    </ListPlaceholderBase>
  );
}

export const ListPlaceholder = memo(ListPlaceholderInner);
